import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=b847ad74&"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports